const key = 'isStatusViewed';

export function isKycStatusViewed() {
    return localStorage.getItem(key) === 'true';
}

export function setKycStatusViewed(value: boolean) {
    return localStorage.setItem(key, value.toString());
}

export function resetKycStatusViewed(oldStatus?: string, newStatus?: string) {
    if (oldStatus !== newStatus) {
        setKycStatusViewed(false);
    }
}
